/* Layers — artist collection: material filter + sort (native Shopify filters) */
(function () {
  document.addEventListener('change', function (event) {
    var el = event.target;

    // Filter select: option values are Shopify filter URLs (url_to_add / url_to_remove)
    if (el.matches('[data-lyr-filter]')) {
      if (el.value) window.location.href = el.value;
      return;
    }

    // Sort select: keep active filters, reset pagination
    if (el.matches('[data-lyr-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });
})();
